import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Navigate } from "react-router-dom";

import {
  getEncuestas,
  setFormulario,
  setPreguntaActiva,
  getUsuario,
  setAnswer,
} from "../actions";

import { Container, Row, Col, Button, ListGroup } from "react-bootstrap";

import logo1 from "../img/cmdic-forta-05.png";
import logo2 from "../img/cmdic-forta-02.png";
import logo3 from "../img/cmdic-forta-03.png";
import logo4 from "../img/cmdic-forta-04.png";
import logo5 from "../img/cmdic-forta-04.png";
import logo6 from "../img/cmdic-forta-03.png";
import logo7 from "../img/cmdic-forta-02.png";
import logo8 from "../img/cmdic-forta-05.png";
import { ReactComponent as Icono1 } from "../img/check-circle.svg";
import { ReactComponent as Icono2 } from "../img/hourglass.svg";

const Inicio = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  //const usuario = useSelector((state) => state.usuario);

  const usuario = {
    UserId: "8777925-4",
    Detail: {
      Survey11101: 0,
      Survey11102: 0,
      Survey11103: 0,
      Survey11104: 0,
      Survey11105: 0,
      Survey11106: 0,
      Survey11107: 0,
      Survey11108: 0,
      Survey11109: 0,
    },
  };

  const respuestas = usuario.Detail;

  //const respuestas = JSON.parse(usuario.Detail);

  const preguntaActiva = useSelector((state) => state.preguntaActiva);
  const ticket = useSelector((state) => state.ticket);

  //
  //console.log("preguntaActiva,ticket", preguntaActiva, ticket);
  //

  const handleClick = (props) => {
    const payload = {
      id_instrumento: props.id_instrumento,
      id_pregunta: props.id_pregunta,
      contador: 1,
    };
    // Reinicia el historial del orden aleatorio SOLO al (re)entrar al Test 3;
    // no se toca al iniciar otros tests, para no borrar el indicador "Finalizado" del 203.
    if (props.id_instrumento === 203) payload.respuestas203 = [];
    dispatch(setPreguntaActiva(payload));
  };

  if (preguntaActiva.id_instrumento === 202)
    return <Navigate to="/pregunta-202" replac="true" />;

  if (preguntaActiva.id_instrumento === 203)
    return <Navigate to="/pregunta-203" replac="true" />;

  if (preguntaActiva.id_instrumento === 204)
    return <Navigate to="/pregunta-204" replac="true" />;

  if (preguntaActiva.id_instrumento === 205)
    return <Navigate to="/pregunta-205" replac="true" />;

  if (preguntaActiva.id_instrumento === 206)
    return <Navigate to="/pregunta-206" replac="true" />;

  if (preguntaActiva.id_instrumento === 208)
    return <Navigate to="/pregunta-208" replac="true" />;

  const BotonNew = (props) => {
    //console.log("props", props);
    const _d = props.datos;
    if (_d.respuestas >= _d.total || _d.total_origen >= _d.total) {
      return (
        <div className="mt-auto">
          {/* <p className="mt-4 xz-texto-v text-center">
            <span className="">{_d.titulo} terminado</span>
          </p>
          <div className="text-center">
            <Icono1 fill="#003e00" width="3em" height="3em" />
          </div> */}
          <Row>
            <Col className="col-12">
              <p className="xz-texto-inicio mb-2">
                <span className="">{_d.titulo}</span>
                <br />

                <span className="xz-texto-reloj"> Finalizado</span>
              </p>
            </Col>
          </Row>
        </div>
      );
    } else
      return (
        <div className="mt-auto text-center">
          <a
            href="#"
            className="btn xz-btn-inicio mt-auto align-self-start"
            onClick={handleClick.bind(this, {
              id_instrumento: _d.id_instrumento,
              id_pregunta: _d.id_pregunta,
            })}
          >
            <Row>
              <Col className="col-12">
                <p className="xz-texto-inicio mb-n1">
                  <span className="">{_d.titulo}</span>
                  <br />
                  <Icono2
                    className="xz-texto-reloj"
                    fill="#003e00"
                    width="10%"
                    height="1em"
                  />{" "}
                  <span className="xz-texto-reloj"> {_d.minutos} min</span>
                </p>
              </Col>
            </Row>
            <Row className="mt-n3">
              <Col className="col-12">
                <p className=""></p>
              </Col>
            </Row>
          </a>{" "}
        </div>
      );
  };

  return (
    <Container>
      <Row>
        <Col>
          <h4 className="mb-2 ms-sm-5">
            Bienvenido/a al proceso de evaluación N°{" "}
            <span className="titulo2">
              {" "}
              {ticket.id_usuario + " : " + ticket.Ticket}
            </span>
          </h4>
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <Row className="ms-sm-5">
            <Col className="col-12 col-md-6 xz-texto-instr">
              <p>
                A continuación encontrará 6 pruebas para medir su grado de
                afinidad con el enfoque de Gestión de Riesgos y Seguridad de
                Collahuasi, para desarrollar una minería de clase mundial.
              </p>
              <p>
                Cada test tiene su instrucción, la cual deberá leer antes de
                comenzar, chequeando que dispone del tiempo para desarrollar la
                prueba. Si se demora más de lo esperado, podrían invalidarse sus
                resultados.
              </p>
            </Col>
            <Col className="col-12 col-md-6 xz-texto-instr">
              {" "}
              <p>
                En cada uno de estos test se le solicita que se autodescriba. No
                existen respuestas correctas o incorrectas, porque las personas
                difieren en sus intereses y actitudes como forma natural y
                normal de <strong>"formas de ser"</strong>. Conteste de la forma
                mas sincera y honesta posible, de modo que su autodescripción
                permita disponer de una información válida y confiable respecto
                a su propia percepción de como <strong>"usted se ve"</strong>.
              </p>
              <p>¿Estás listo/a?</p>
              <p>Haz click en cada test y comience.</p>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row className="m-sm-5">
            <Col className="xz-col-xs text-center">
              <BotonNew
                datos={{
                  id_instrumento: 202,
                  id_pregunta: 20201,
                  total: 32,
                  minutos: "12",
                  respuestas: preguntaActiva.respuestas202.length,
                  titulo: "Test 1",
                  total_origen: ticket.id_instrumento_202,
                }}
              />
            </Col>
            <Col className="xz-col-xs text-center">
              <BotonNew
                datos={{
                  id_instrumento: 208,
                  id_pregunta: 20801,
                  total: 40,
                  minutos: "10",
                  respuestas: preguntaActiva.respuestas208.length,
                  titulo: "Test 2",
                  total_origen: ticket.id_instrumento_208,
                }}
              />
            </Col>
            <Col className="xz-col-xs text-center">
              <BotonNew
                datos={{
                  id_instrumento: 203,
                  id_pregunta: 20301,
                  total: 5,
                  minutos: "7",
                  respuestas: preguntaActiva.respuestas203.length,
                  titulo: "Test 3",
                  total_origen: ticket.id_instrumento_203,
                }}
              />
            </Col>
          </Row>
          <Row className="m-sm-5 mb-2">
            <Col className="xz-col-xs text-center">
              <BotonNew
                datos={{
                  id_instrumento: 204,
                  id_pregunta: 20401,
                  total: 53,
                  minutos: "16",
                  respuestas: preguntaActiva.respuestas204.length,
                  titulo: "Test 4",
                  total_origen: ticket.id_instrumento_204,
                }}
              />
            </Col>

            <Col className="xz-col-xs text-center">
              <BotonNew
                datos={{
                  id_instrumento: 205,
                  id_pregunta: 20501,
                  total: 44,
                  minutos: "16",
                  respuestas: preguntaActiva.respuestas205.length,
                  titulo: "Test 5",
                  total_origen: ticket.id_instrumento_205,
                }}
              />
            </Col>
            <Col className="xz-col-xs text-center">
              <BotonNew
                datos={{
                  id_instrumento: 206,
                  id_pregunta: 20601,
                  total: 10,
                  minutos: "10",
                  respuestas: preguntaActiva.respuestas206.length,
                  titulo: "Test 6",
                  total_origen: ticket.id_instrumento_206,
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default Inicio;
